import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showDetailsReportingDialog, Utils } from 'app/main/components';
import { showKpisGoalsEditDialog } from 'app/main/submodules/kpis/components/KpisGoalsEditDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showFastAddDialog } from '../components/FastAddDialog';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer, model, userData }) => {
					if (model.user_uid === userData.user_uid) return false;
					return authorizer.cannot('update', 'users');
				},
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'users', updateRefresh, isUpdate: true, model }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('chronology') || authorizer.cannot('create', 'chronology'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: {
								chro_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('activities') || authorizer.cannot('create', 'activities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: {
								acti_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_OPPORTUNITY',
				icon: 'thought-bubble-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('opportunities') || authorizer.cannot('create', 'opportunities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'opportunities',
							updateRefresh,
							model: {
								oppo_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_MARKETINGACTION',
				icon: 'bullhorn',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('marketingactions') || authorizer.cannot('create', 'marketingactions'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'marketingactions',
							updateRefresh,
							model: {
								maac_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_COMMERCIALCAMPAIGNS',
				icon: 'binoculars',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('commercialcampaigns') || authorizer.cannot('create', 'commercialcampaigns'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'commercialcampaigns',
							updateRefresh,
							model: {
								cmcp_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_DEM',
				icon: 'email-multiple-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('dems') || authorizer.cannot('create', 'dems'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'dems',
							updateRefresh,
							model: {
								dems_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_CONTRACT',
				icon: 'file-document-edit-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('contracts') || authorizer.cannot('create', 'contracts'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'contracts',
							updateRefresh,
							model: {
								cntr_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_ORDER',
				icon: 'basket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('orders') || authorizer.cannot('create', 'orders'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'orders',
							updateRefresh,
							model: {
								ords_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_PROJECT',
				icon: 'clipboard-text-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('projects') || authorizer.cannot('create', 'projects'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'projects',
							updateRefresh,
							model: {
								proj_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_WORKREPORT',
				icon: 'text-box-multiple-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('workreports') || authorizer.cannot('create', 'workreports'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'workreports',
							updateRefresh,
							model: {
								wore_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_TICKET',
				icon: 'ticket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('tickets') || authorizer.cannot('create', 'tickets'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'tickets',
							updateRefresh,
							model: {
								tick_user_assigned_uid: model.user_uid
							}
						})
					)
			}
		],
		headerButtons: [
			// {
			// 	name: 'VIEW_HEADER_BUTTON_SELECT',
			// 	icon: 'square-outline',
			// 	action: ({ switchIsSelecting }) => switchIsSelecting()
			// },
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'users'),
				action: () => Utils.openLink({ pathname: '/users/add' })
			}
		]
	},
	details: {
		headerButtons: [
			{
				name: 'DETAILS_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				hidden: ({ authorizer }) => authorizer.cannot('export', 'users'),
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				disabled: ({ isEdit }) => isEdit,
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				action: ({ switchShowLogs }) => switchShowLogs()
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer, model, userData }) => {
					if (model.user_uid === userData.user_uid) return false;
					return authorizer.cannot('update', 'users');
				},
				action: ({ switchEdit }) => switchEdit()
			},
			{
				id: 'kpis-goals',
				name: 'BUTTON_KPI_GOAL_NEW',
				icon: 'target-arrow',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('sys_kpis_goals') || authorizer.cannot('create', 'sys_kpis_goals'),
				action: ({ dispatch, updateRefresh, model }) => {
					dispatch(
						showKpisGoalsEditDialog({
							aggregation: { module: 'users', value: model.user_uid },
							isAdd: true,
							updateRefresh
						})
					);
				}
			},
			{
				id: 'chronology',
				name: 'DETAILS_HEADER_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('chronology') || authorizer.cannot('create', 'chronology'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: {
								chro_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				id: 'activities',
				name: 'DETAILS_HEADER_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('activities') || authorizer.cannot('create', 'activities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: {
								acti_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				id: 'opportunities',
				name: 'DETAILS_HEADER_BUTTON_NEW_OPPORTUNITY',
				icon: 'thought-bubble-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('opportunities') || authorizer.cannot('create', 'opportunities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'opportunities',
							updateRefresh,
							model: {
								oppo_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				id: 'marketingactions',
				name: 'DETAILS_HEADER_BUTTON_NEW_MARKETINGACTION',
				icon: 'bullhorn',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('marketingactions') || authorizer.cannot('create', 'marketingactions'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'marketingactions',
							updateRefresh,
							model: {
								maac_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				id: 'commercialcampaigns',
				name: 'DETAILS_HEADER_BUTTON_NEW_COMMERCIALCAMPAIGN',
				icon: 'binoculars',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('commercialcampaigns') || authorizer.cannot('create', 'commercialcampaigns'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'commercialcampaigns',
							updateRefresh,
							model: {
								cmcp_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				id: 'dems',
				name: 'DETAILS_HEADER_BUTTON_NEW_DEM',
				icon: 'email-multiple-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('dems') || authorizer.cannot('create', 'dems'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'dems',
							updateRefresh,
							model: {
								dems_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				id: 'contracts',
				name: 'DETAILS_HEADER_BUTTON_NEW_CONTRACT',
				icon: 'file-document-edit-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('contracts') || authorizer.cannot('create', 'contracts'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'contracts',
							updateRefresh,
							model: {
								cntr_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				id: 'orders',
				name: 'VIEW_ITEM_BUTTON_NEW_ORDER',
				icon: 'basket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('orders') || authorizer.cannot('create', 'orders'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'orders',
							updateRefresh,
							model: {
								ords_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				id: 'projects',
				name: 'DETAILS_HEADER_BUTTON_NEW_PROJECT',
				icon: 'clipboard-text-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('projects') || authorizer.cannot('create', 'projects'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'projects',
							updateRefresh,
							model: {
								proj_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				id: 'workreports',
				name: 'DETAILS_HEADER_BUTTON_NEW_WORKREPORT',
				icon: 'text-box-multiple-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('workreports') || authorizer.cannot('create', 'workreports'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'workreports',
							updateRefresh,
							model: {
								wore_user_assigned_uid: model.user_uid
							}
						})
					)
			},
			{
				id: 'tickets',
				name: 'DETAILS_HEADER_BUTTON_NEW_TICKET',
				icon: 'ticket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('tickets') || authorizer.cannot('create', 'tickets'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'tickets',
							updateRefresh,
							model: {
								tick_user_assigned_uid: model.user_uid
							}
						})
					)
			}
		]
	}
};

export default buttons;
